export default "__VITE_ASSET__G7_wi4CE__"